import React from "react";

const Vendors = () => {
  return (
    <div className="bg-neutrals-100 flex flex-col justify-center items-center  h-full overflow-auto ">
      <div className="flex flex-col justify-center items-center m-10">
        <h1 className="flex font-bold text-center items-center  break-words">
          Vendors
        </h1>
        <h2 className="flex font-bold text-center items-center  break-words">
          Coming soon
        </h2>
      </div>
    </div>
  );
};

export default Vendors;
